<template>
    <div class="common-title-box" :style="getStyle">
        <div class="common-title">{{ title }}</div>
        <ul class="tag-list" v-if="tagConfig?.show ?? true">
            <li
                :class="[{ active: curTag === item.value }]"
                v-for="item in realList"
                :key="item.tagKey"
                @click="changeTag(item.value)"
            >
                {{ item.tagName }}
            </li>
        </ul>
        <slot></slot>
        <div v-if="props.showMore">
            <a class="more" @click="goMore" href="javascript:;">更多&nbsp;&gt;</a>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, computed } from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    showMore: {
        type: Boolean,
        default: true,
    },
    tagList: {
        type: Array,
        default: () => {
            return [];
        },
    },
    titleColor: {
        type: String,
        default: '#2164C9',
    },
    tagColor: {
        type: String,
        default: '#000',
    },
    moreColor: {
        type: String,
        default: '#2164C9',
    },
    hoverColor: {
        type: String,
        default: '#2164C9',
    },
    defaultTag: {
        type: [String, Number],
    },
    tagConfig: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(['goMore', 'changeTag']);

const curTag = ref(props.defaultTag ?? []);

const getStyle = computed(() => {
    return `
        --title-color: ${props.titleColor};
        --tag-color: ${props.tagColor};
        --more-color: ${props.moreColor};
        --hover-color: ${props.hoverColor};
    `;
});

const realList = computed(() => {
    return props.tagList.filter(item => item.checked);
});

const goMore = () => {
    emit('goMore');
};

const changeTag = (tag = []) => {
    curTag.value = curTag.value === tag ? [] : tag;
    emit('changeTag', curTag.value);
};
</script>

<style lang="scss" scoped>
.common-title-box {
    display: flex;
    justify-content: space-between;
    // align-items: center;
    margin-top: 40px;
    border-bottom: 1px solid var(--home-border-color);
    .common-title {
        border-bottom: 4px solid var(--title-color);
        padding-bottom: 10px;
        font-size: 22px;
        font-weight: bold;
        color: var(--title-color);
        line-height: 29px;
        margin-bottom: -1px;
    }
    .more {
        font-size: 14px;
        color: var(--more-color);
        line-height: 14px;
        margin-top: 10px;
        display: block;
        user-select: none;
    }
    .tag-list {
        flex: 1;
        display: flex;
        padding: 0 20px;
        margin-top: 10px;
        li {
            margin: 0 10px;
            line-height: 14px;
            cursor: pointer;
            user-select: none;
            &.active {
                color: var(--hover-color);
            }
        }
    }
}
</style>
